/** Pack create/update can wait on App Store / Play sync — avoid 20s client abort. */
export const PACK_WRITE_TIMEOUT_MS = 120000;
